/***************************************************************************
 * FILTER SELECT - SET ACTIVE CLASS NAME
 * This script will handle the active class name of the filter select
 * element. The active class will be set on click on a filter select
 * element and unset on a second click or on click anywhere else.
 **************************************************************************/

/**
 * GET FILTER SELECT ELEMENTS
 *
 * This function will return the
 * DOM of the filter selects.
 *
 * @requires string
 *
 * @return HTMLCollection
 */
function getFilterSelectElements() {
    return document.getElementsByClassName('filterSelect');
}


/**
 * GET HTML COLLECTION AS ARRAY
 *
 * This function will return the
 * DOM of the filter selects.
 *
 * @requires HTMLCollection
 *
 * @return array
 */
function getHtmlCollectionAsArray(htmlCollection) {
    if (htmlCollection) {
        return [].slice.call(htmlCollection);
    }
}


/**
 * GET PARENT ELEMENTS OF ELEMENT
 *
 * This function will get all parent
 * elements of the transmitted element
 * and returns it as an array.
 *
 * @requires element
 *
 * @return array
 */
function getParentElementsOfElement(element) {
    var arrayWithAllParentElements = [];
    while (element) {
        arrayWithAllParentElements.unshift(element);
        element = element.parentNode;
    }
    return arrayWithAllParentElements;
}


/**
 * CONTAINS ANY
 *
 * This function will compare
 * two arrays together and return
 * true or false depending on the fact
 * if they have a same value in it.
 *
 * @requires array, array
 *
 * @return boolean
 */
function containsAny(source,target)
{
    var result = source.filter(function(item){ return target.indexOf(item) > -1});
    return (result.length > 0);
}


function parentFilterSelectElementFromClickedElement(clickedElement, allElementsFromClickedType) {
    for (var i = 0; i < allElementsFromClickedType.length; i++) {
        if (getParentElementsOfElement(clickedElement).includes(allElementsFromClickedType[i])) {
            return allElementsFromClickedType[i];
        }
    }
}


/**
 * SET ACTIVE CLASS NAME
 *
 * This function will set an
 * active class name on the
 * transmitted DOM element.
 *
 * @requires element, array
 *
 * @return DOM
 */
function setHandleActiveClassName(clickedElement, allElementsFromClickedType) {
    // return false if a variable is empty
    if (!(clickedElement || allElementsFromClickedType)) {
        return false;
    }

    // get data
    var clickedEl = parentFilterSelectElementFromClickedElement(clickedElement, allElementsFromClickedType);

    // remove the active class name if the clicked element has already an active class name
    if (clickedEl && clickedEl.classList.contains('active')) {
        clickedEl.classList.remove('active');
        return;
    }

    // remove all active class names
    for (var i = 0; i < allElementsFromClickedType.length; i++) {
        allElementsFromClickedType[i].classList.remove('active');
    }

    // set active class name
    if (containsAny(getParentElementsOfElement(clickedElement), getHtmlCollectionAsArray(allElementsFromClickedType))) {
        clickedEl.classList.add('active');
    }
}


/**
 * SET FILTER SELECT ACTIVE CLASS NAME ON CLICK
 *
 * This function will set on click
 * the active class name on the filter
 * select elements.
 *
 * @requires elements
 *
 * @return DOM
 */
function SetFilterSelectActiveClassNameOnClick(filterSelectElements) {
    if (filterSelectElements) {
        document.addEventListener('click', function (e) {
            setHandleActiveClassName(e.target, filterSelectElements);
        });
        return;
    }
    return false;
}


// Execute functions
document.addEventListener('DOMContentLoaded', function() {
    SetFilterSelectActiveClassNameOnClick(getFilterSelectElements());



    // TODO: REFACTOR/SPLIT UP CODE WHEN YOU HAVE OR GET MORE TIME!
    /*********************************************************
     * Add '.changed' className to 'form' & '.filterSelect'
     * when the checkbox checked state has changed.
     *********************************************************/
    filterSetChangedStatus();
    function filterSetChangedStatus() {
        // Get array of filter groups
        var arrayOfFilterGroups = document.querySelectorAll('.searchFilter > .filters > .filterGroups > div');

        // Get array of filter checkboxes
        var arrayOfFilterCheckboxes = document.querySelectorAll('.searchFilter > .filters input[type="checkbox"]');

        // Loop through all checkboxes
        for (var checkbox = 0; checkbox < arrayOfFilterCheckboxes.length; checkbox++) {

            // Add event listener for checkboxes
            arrayOfFilterCheckboxes[checkbox].addEventListener('change', function () {

                // Loop through all filter groups
                for (var filterGroup = 0; filterGroup < arrayOfFilterGroups.length; filterGroup++) {

                    // Get array of all checkboxes fo the filter group
                    var filterGroupItem = arrayOfFilterGroups[filterGroup];
                    var arrayOfFilterGroupCheckboxes = filterGroupItem.querySelectorAll('input[type="checkbox"]');

                    // Remove '.changed' className from '.filterSelect > span'
                    filterGroupItem.getElementsByClassName('filterSelect')[0].getElementsByTagName('span')[0].classList.remove('changed');

                    // Loop through all checkboxes of a filter group
                    for (var filterGroupCheckbox = 0; filterGroupCheckbox < arrayOfFilterGroupCheckboxes.length; filterGroupCheckbox++) {
                        var filterGroupCheckboxItem = arrayOfFilterGroupCheckboxes[filterGroupCheckbox];

                        // Add '.changed' className to '.filterSelect span' if checkbox checked value has changed
                        if (filterGroupCheckboxItem.defaultChecked !== filterGroupCheckboxItem.checked) {
                            filterGroupItem.getElementsByClassName('filterSelect')[0].getElementsByTagName('span')[0].classList.add('changed');
                        }
                    }
                }
            }, false);
        }
    }
});